export const RUSH_DAYS_MAP = {
  "24 Hour Rush": 1,
  "3 Day Rush": 3,
  "1 Week Rush": 5,
};

export const SHIPPING_SERVICE_LABEL = {
  "3DaySelect": "3 Day Select",
  "2ndDayAir": "2nd Day Air",
  NextDayAir: "Next Day Air",
  NextDayAirSaver: "Next Day Air Saver",
  NextDayAirEarlyAM: "Next Day Air Early AM",
  First: "First Class",
  ParcelSelect: "Parcel Select",
  MailViewLight: "Mail View Light",
  ExpressWorldwideNonDoc: "Express Worldwide Non Doc",
};

/**
 * USPS and FIMS are slower shipping methods. They are unreliable and cannot be used if rush is selected.
 * https://trello.com/c/ys4ziCG6/478-restrict-usps-and-fims-from-being-used-in-rush-orders
 */
export const BLOCKED_SHIPPING_PROVIDERS = ["USPS", "FedExMailView", "FedExCrossBorder"];

export const PROVIDER_TRANSITS = {
  FedExCrossBorder: "10-20 Business Days",
};

export const SERVICE_TRANSITS = {
  FEDEX_INTERNATIONAL_CONNECT_PLUS: "2-5 Business Days",
  FirstClassPackageInternationalService: "6-20 Business Days",
  PriorityMailInternational: "6-10 Business Days",
  ExpressMailInternational: "3-5 Business Days",
  INTERNATIONAL_ECONOMY: "2-7 Business Days",
  ExpressWorldwideNonDoc: "1-3 Business Day",
  Express1200NonDoc: "1-3 Business Day",
  INTERNATIONAL_FIRST: "1-3 Business Day",
};

export const useOldMU = process.env.NEXT_PUBLIC_OLD_MAD_UNICORN?.toLowerCase() === "true";
